import cx from 'classnames';
import React from 'react';

import * as styles from './Columns.module.css';

const Columns = ({
	children,
	className = '',
	as: Component = 'div',
	stretch,
	direction,
	gap = 'sm',
	align,
}: {
	children: React.ReactNode[];
	className?: string;
	as?: React.ElementType;
	stretch?: 'former' | 'latter';
	direction?: 'standard' | 'reverse';
	gap?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
	align?: 'left' | 'center' | 'right';
}): JSX.Element => {
	const componentClassNames = cx(styles.columns, {
		[styles[`${direction}Direction`]]: direction,
		[styles[`${stretch}Stretch`]]: stretch,
		[styles[`${gap}Gap`]]: gap,
		[styles[`${align}Align`]]: align,
		[className]: !!className,
	});

	return <Component className={componentClassNames}>{children}</Component>;
};

export default Columns;
